export default {
	name: "competition-submission-form",
	data() {
		return {
			campaignId: null,
			campaign: {},
			campaignName: "Win Fuel For A Year!",
			sites: [],
			selectedSiteId: 0,
			firstName: {
				value: null,
				hasError: false,
				errorMessage: null
			},
			lastName: {
				value: null,
				hasError: false,
				errorMessage: null
			},
			mobileNumber: {
				value: "27",
				hasError: false,
				errorMessage: null
			},
			emailAddress: {
				value: null,
				hasError: false,
				errorMessage: null
			},
			cardBarcode: {
				value: null,
				hasError: false,
				errorMessage: null
			},
			tillSlipImage:{
				value: null,
				hasError: false,
				errorMessage: null
			},
			acceptTermsAndConditions:{
				value: false,
				hasError: false,
				errorMessage: null
			},
			loading: false,
			showSuccessMessage: false,
			loadingFromApi: false,
			hasLoadedCampaign: false,
			hasLoadedSites: false,
			showTakePictureButton: false
		};
	},
	methods: {
		getCampaign(){
			this.loadingFromApi = true;
			
			competitionService.getCampaign(this.campaignId).then(
				response =>{
					if(response.status === 200){
						this.campaign = response.data.result;
						this.campaign.isAnActiveCampaign = response.data.isAnActiveCampaign;
						this.campaign.bannerAsBase64 = response.data.bannerAsBase64;
						console.log("campaign", this.campaign);
					}
					this.hasLoadedCampaign = true;
					if(this.hasLoadedCampaign && this.hasLoadedSites){
						this.loadingFromApi = false;
						var self = this;
						setTimeout(function (){
							var element = document.getElementById("backgroundImage");
							// console.log("element", element);
							if(self.campaign.bannerAsBase64 !== null && self.campaign.bannerAsBase64 !== undefined){
								if(element !== null) {
									document.getElementById("backgroundImage").setAttribute("style", "background-image: url('" + self.campaign.bannerAsBase64 + "')");
								}
							}
						}, 500);
						
					}
				}
			);
		},
		getSites(){
			this.loadingFromApi = true;
			competitionService.getSitesByCampaign(this.campaignId).then(
				response =>{
					if(response.status === 200){
						this.sites = response.data.result;
						this.sites = $.map(this.sites,
							function (obj) {
								obj.id = obj.id || obj.siteId;
								obj.text = obj.text || obj.siteName;
								return obj;
							});
						if(this.sites !== null && this.sites !== undefined && this.sites.length > 0){
							this.selectedSiteId = this.sites[0].id;
						}
					}
					this.hasLoadedSites = true;
					if(this.hasLoadedCampaign && this.hasLoadedSites){
						this.loadingFromApi = false;
						// let element = document.getElementById("backgroundImage");
						var self = this;
						setTimeout(function (){
							var element = document.getElementById("backgroundImage");
							// console.log("element", element);
							if(self.campaign.bannerAsBase64 !== null && self.campaign.bannerAsBase64 !== undefined){
								if(element !== null) {
									document.getElementById("backgroundImage").setAttribute("style", "background-image: url('" + self.campaign.bannerAsBase64 + "')");
								}
							}
						}, 500);
					}
				}
			);
			// systemService.getSites().then(
			// 	successResponse => {
			// 		let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
			// 		if(isSuccess){
			// 			//success
			// 			console.log("success", successResponse);
			// 			this.sites = successResponse.data.result;
			// 			this.sites = $.map(this.sites,
			// 				function (obj) {
			// 					obj.id = obj.id || obj.siteId;
			// 					obj.text = obj.text || obj.name;
			// 					return obj;
			// 				});
			// 			if(this.sites !== null && this.sites !== undefined && this.sites.length > 0){
			// 				this.selectedSiteId = this.sites[0].id;
			// 			}
			// 		}
			// 	},
			// 	errorResponse => {
			// 		//error
			// 		console.log("error", errorResponse);
			// 		//apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
			// 	}
			// );
		},
		onMobileNumberInput(){
			console.log("length", this.mobileNumber.value.length)
			if(this.mobileNumber.value === null || this.mobileNumber.value === ""){
				this.mobileNumber.value = "27";
			}
				// else{
				//     this.mobileNumber.value = "27" + this.mobileNumber.value;
			// }
			else if(this.mobileNumber.value.length < 2){
				this.mobileNumber.value = "27";
			}
			else{
				this.mobileNumber.value = "27" + this.mobileNumber.value.substring(2);
			}
		},
		onSiteDropdownChange(site){
			console.log("Site dropdown change");
			console.log(site);
			this.selectedSiteId = site.id;
		},
		onTillSlipAttach(event){
			event.preventDefault();
			this.tillSlipImage.value = event.target.files[0];
			sessionStorage.setItem("tillSlipImage", this.tillSlipImage.value);
			console.log("tillSlipImage", this.tillSlipImage.value);
		},
		submitCompetitionEntry(){
			this.loading = true;
			let request = {
				campaignId: this.campaignId,
				siteId: this.selectedSiteId,
				firstName: this.firstName.value,
				lastName: this.lastName.value,
				mobileNumber: this.mobileNumber.value,
				cardNumber: this.cardBarcode.value,
				emailAddress: this.emailAddress.value,
				acceptTermsAndConditions: this.acceptTermsAndConditions.value
			};
			let formData = new FormData();
			formData.append("request", JSON.stringify(request));
			formData.append("tillSlip", this.tillSlipImage.value);
			competitionService.addOrUpdateSubmission(formData).then(
				response =>{
					if (response.status === 400){
						if(response.data.competitionEntrySubmissionValidationResponse.firstNameValidationResponse !== null){
							this.firstName.hasError = response.data.competitionEntrySubmissionValidationResponse.firstNameValidationResponse.hasError;
							this.firstName.errorMessage = response.data.competitionEntrySubmissionValidationResponse.firstNameValidationResponse.message;
						}
						
						if(response.data.competitionEntrySubmissionValidationResponse.lastNameValidationResponse !== null){
							this.lastName.hasError = response.data.competitionEntrySubmissionValidationResponse.lastNameValidationResponse.hasError;
							this.lastName.errorMessage = response.data.competitionEntrySubmissionValidationResponse.lastNameValidationResponse.message;
						}
						
						if(response.data.competitionEntrySubmissionValidationResponse.mobileNumberValidationResponse !== null){
							this.mobileNumber.hasError = response.data.competitionEntrySubmissionValidationResponse.mobileNumberValidationResponse.hasError;
							this.mobileNumber.errorMessage = response.data.competitionEntrySubmissionValidationResponse.mobileNumberValidationResponse.message;
						}
						
						if(response.data.competitionEntrySubmissionValidationResponse.emailAddressValidationResponse !== null){
							this.emailAddress.hasError = response.data.competitionEntrySubmissionValidationResponse.emailAddressValidationResponse.hasError;
							this.emailAddress.errorMessage = response.data.competitionEntrySubmissionValidationResponse.emailAddressValidationResponse.message;
						}
						
						if(response.data.competitionEntrySubmissionValidationResponse.tillSlipValidationResponse !== null){
							this.tillSlipImage.hasError = response.data.competitionEntrySubmissionValidationResponse.tillSlipValidationResponse.hasError;
							this.tillSlipImage.errorMessage = response.data.competitionEntrySubmissionValidationResponse.tillSlipValidationResponse.message;
						}
						
						if(response.data.competitionEntrySubmissionValidationResponse.acceptTermsAndConditionsValidationResponse !== null) {
							this.acceptTermsAndConditions.hasError = response.data.competitionEntrySubmissionValidationResponse.acceptTermsAndConditionsValidationResponse.hasError;
							this.acceptTermsAndConditions.errorMessage = response.data.competitionEntrySubmissionValidationResponse.acceptTermsAndConditionsValidationResponse.message;
						}
					}
					if(response.status === 200){
						this.showSuccessMessage = true;
					}
					this.loading = false;
				}
			);
		},
	},
	mounted: function () {
		// Create a URL object
		let urlParams = new URL(window.location.href).searchParams;
		this.campaignId = urlParams.get('campaignId');
		console.log("campaignId", this.campaignId);
		this.getCampaign();
		this.getSites();
		this.showTakePictureButton = deviceHelper.mobileAndTabletCheck();
		var a = sessionStorage.getItem("tillSlipImage");
		console.log("file", a);
	}
};